// extracted by mini-css-extract-plugin
export default {"value":"Eq2baKpfPuWaSL_XyoCB"};